import { CalendarPlus, Download } from "lucide-react";

/**
 * 工事日が確定した瞬間に、業者・顧客の双方が自分のカレンダーへ登録できるボタン。
 * Googleカレンダー追加リンク（OAuth不要）＋ ICS ダウンロード（Apple/Outlook対応）。
 */
function pad(n: number) { return String(n).padStart(2, "0"); }
function ymd(d: Date) { return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}`; }

export function CalendarButtons({
  dateISO, title, location, details,
}: { dateISO: string; title: string; location?: string; details?: string }) {
  const start = new Date(dateISO);
  if (isNaN(start.getTime())) return null;
  const end = new Date(start); end.setDate(end.getDate() + 1); // 終日（end は排他）
  const dates = `${ymd(start)}/${ymd(end)}`;
  const gUrl =
    `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(title)}&dates=${dates}` +
    (details ? `&details=${encodeURIComponent(details)}` : "") +
    (location ? `&location=${encodeURIComponent(location)}` : "");

  function downloadIcs() {
    const body = [
      "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//sirasu//shitamy//JA", "CALSCALE:GREGORIAN",
      "BEGIN:VEVENT",
      `UID:${ymd(start)}-${Math.random().toString(36).slice(2)}@sita-me.com`,
      `DTSTAMP:${ymd(new Date())}T000000Z`,
      `DTSTART;VALUE=DATE:${ymd(start)}`,
      `DTEND;VALUE=DATE:${ymd(end)}`,
      `SUMMARY:${title}`,
      location ? `LOCATION:${location}` : "",
      details ? `DESCRIPTION:${details}` : "",
      "END:VEVENT", "END:VCALENDAR",
    ].filter(Boolean).join("\r\n");
    const url = URL.createObjectURL(new Blob([body], { type: "text/calendar" }));
    const a = document.createElement("a");
    a.href = url; a.download = "shitamy-koji.ics"; a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <div className="flex gap-2">
      <a
        href={gUrl} target="_blank" rel="noopener noreferrer"
        className="flex-1 flex items-center justify-center gap-1.5 border border-brand-500 text-brand-600 dark:text-brand-300 text-xs font-bold py-2 rounded-xl active:scale-95 transition"
      >
        <CalendarPlus size={14} /> Googleカレンダーに追加
      </a>
      <button
        onClick={downloadIcs}
        className="flex items-center justify-center gap-1.5 border border-[var(--color-border)] text-ink-soft dark:text-white/70 text-xs font-bold px-3 py-2 rounded-xl active:scale-95 transition"
        aria-label="ICSをダウンロード"
      >
        <Download size={14} /> ICS
      </button>
    </div>
  );
}
